module.exports = __webpack_public_path__ + "static/strategy-9587a2162226f237b0bd98e90630e84f.svg";